import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from "@mui/material";
import { useI18N } from "../../context/I18NContext";
import { durationFormat, moneyFormat } from "../../helpers/general";
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
export const PaymentOptionProviderExternal = ({ provider }) => {
    const { t } = useI18N();
    const theme = useTheme();
    return (_jsxs(_Fragment, { children: [t(provider === null || provider === void 0 ? void 0 : provider.label), _jsxs("span", { style: {
                    color: theme.palette.text.disabled,
                    display: 'block'
                }, children: [" ", t('Betaal je afspraak op een andere wijze', "payment"), " "] })] }));
};
export const PaymentOptionProviderAlternate = ({ provider }) => {
    const { t } = useI18N();
    const theme = useTheme();
    return (_jsxs(_Fragment, { children: [t(provider === null || provider === void 0 ? void 0 : provider.label), _jsxs("span", { style: {
                    color: theme.palette.text.disabled,
                    display: 'block'
                }, children: [t('Schaf een abonnement of strippenkaart aan'), " "] })] }));
};
export const PaymentOptionProviderNone = ({ provider }) => {
    const { t } = useI18N();
    const theme = useTheme();
    return (_jsxs(_Fragment, { children: [t(provider === null || provider === void 0 ? void 0 : provider.label), _jsxs("span", { style: {
                    color: theme.palette.text.disabled,
                    display: 'block'
                }, children: [t('Betaal bij je afspraak', "payment"), " "] })] }));
};
export const PaymentOptionSubscriptionUse = ({ subscription, addPayment, addSubscription, invoiceTotal, addSubscriptions }) => {
    const { t, ts } = useI18N();
    const theme = useTheme();
    let cost = parseFloat(subscription.balance).toFixed(0).toString();
    if (cost === "-1")
        cost = t('onbeperkt');
    return (_jsxs(_Fragment, { children: [_jsxs(_Fragment, { children: [t('Gebruik je strippenkaart', "payment"), " ", subscription.title] }), _jsxs("span", { style: {
                    display: 'block',
                }, children: [addPayment && invoiceTotal && (_jsx(_Fragment, { children: ts('Betaal het restant van %total% bij', { total: moneyFormat(invoiceTotal) }) })), addSubscription && invoiceTotal && addSubscriptions && (_jsx(_Fragment, { children: ts('Koop %amount% %amount=1?strippenkaart:strippenkaarten% aan voor %total% voor het restant van de benodigde strippen', { total: moneyFormat(invoiceTotal), amount: addSubscriptions }) }))] }), _jsxs("span", { style: {
                    color: theme.palette.text.disabled,
                    display: 'block'
                }, children: [subscription.endDate ? `${t('Geldig tot')} ${dayjs(subscription.endDate).locale('nl').format('D MMMM YYYY')}` : t('Onbeperkt geldig'), _jsx("br", {}), cost, " ", t('strippen beschikbaar')] })] }));
};
export const PaymentOptionMembershipUse = ({ subscription }) => {
    const { t } = useI18N();
    const theme = useTheme();
    return (_jsxs(_Fragment, { children: [_jsxs(_Fragment, { children: [t('Gebruik je abonnement', "payment"), " ", subscription.title] }), _jsx("span", { style: {
                    color: theme.palette.text.disabled,
                    display: 'block'
                }, children: subscription.endDate ? `${t('Geldig tot')} ${dayjs(subscription.endDate).locale('nl').format('D MMMM YYYY')}` : t('Onbeperkt geldig') })] }));
};
export const PaymentOptionSubscriptionBuy = ({ subscription, addSubscription, invoiceTotal, addSubscriptions }) => {
    var _a, _b;
    const { t } = useI18N();
    const theme = useTheme();
    let cost = parseFloat(subscription.balance).toFixed(0).toString();
    if (cost === "-1")
        cost = t('onbeperkt');
    return (_jsxs(_Fragment, { children: [_jsx(_Fragment, { children: subscription.title }), _jsxs("span", { style: {
                    color: theme.palette.text.disabled,
                    display: 'block'
                }, children: [t('Strippenkaart'), ", ", cost, " ", t('strippen'), _jsx("br", {}), ((_a = subscription === null || subscription === void 0 ? void 0 : subscription.validDuration) !== null && _a !== void 0 ? _a : '') !== '' && (_jsxs(_Fragment, { children: [t('Geldig voor'), " ", durationFormat((_b = subscription === null || subscription === void 0 ? void 0 : subscription.validDuration) !== null && _b !== void 0 ? _b : '')] }))] })] }));
};
export const PaymentOptionMembershipBuy = ({ subscription, title }) => {
    var _a, _b;
    const { t } = useI18N();
    const theme = useTheme();
    let _title = title
        ? title
        : subscription.title;
    return (_jsxs(_Fragment, { children: [_jsx(_Fragment, { children: _title }), _jsxs("span", { style: {
                    color: theme.palette.text.disabled,
                    display: 'block'
                }, children: [t('Abonnement'), _jsx("br", {}), ((_a = subscription === null || subscription === void 0 ? void 0 : subscription.validDuration) !== null && _a !== void 0 ? _a : '') !== '' && (_jsxs(_Fragment, { children: [t('Geldig voor'), " ", durationFormat((_b = subscription === null || subscription === void 0 ? void 0 : subscription.validDuration) !== null && _b !== void 0 ? _b : '')] }))] })] }));
};
export const PaymentOptionMembershipMandate = ({ subscription, title }) => {
    var _a, _b, _c, _d, _e;
    const { t } = useI18N();
    const theme = useTheme();
    let _title = title ? title : subscription.title;
    let intervalStr = {
        '1': 'Maandelijkse incasso',
        '3': 'Incasso iedere 3 maanden',
        '6': 'Incasso iedere 6 maanden',
        '12': 'Jaarlijkse incasso'
    };
    return (_jsxs(_Fragment, { children: [_jsx(_Fragment, { children: _title }), _jsxs("span", { style: {
                    color: theme.palette.text.disabled,
                    display: 'block'
                }, children: [t('Abonnement'), _jsx("br", {}), (subscription === null || subscription === void 0 ? void 0 : subscription.initialFee) && (subscription === null || subscription === void 0 ? void 0 : subscription.initialFee) > 0 && (_jsxs(_Fragment, { children: [t('Eenmalig'), " ", moneyFormat((_a = subscription === null || subscription === void 0 ? void 0 : subscription.initialFee) !== null && _a !== void 0 ? _a : 0), _jsx("br", {})] })), intervalStr[(_c = (_b = subscription === null || subscription === void 0 ? void 0 : subscription.intervals) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '1'], _jsx("br", {}), ((_d = subscription === null || subscription === void 0 ? void 0 : subscription.validDuration) !== null && _d !== void 0 ? _d : '') !== '' && (_jsxs(_Fragment, { children: [t('Geldig voor'), " ", durationFormat((_e = subscription === null || subscription === void 0 ? void 0 : subscription.validDuration) !== null && _e !== void 0 ? _e : '')] }))] })] }));
};
export const PaymentOptionProviderRemote = ({ provider, fees, useDeposit }) => {
    const { t } = useI18N();
    const theme = useTheme();
    let feeStr = '', fee = fees[provider === null || provider === void 0 ? void 0 : provider.key];
    if (useDeposit && (fee === null || fee === void 0 ? void 0 : fee.deposit) && (fee === null || fee === void 0 ? void 0 : fee.deposit) > 0) {
        feeStr = ` (+${moneyFormat(fee.deposit / 100)} )`;
    }
    else if ((fee === null || fee === void 0 ? void 0 : fee.full) && (fee === null || fee === void 0 ? void 0 : fee.full) > 0) {
        feeStr = ` (+${moneyFormat(fee.full / 100)} )`;
    }
    return (_jsxs(_Fragment, { children: [t(provider === null || provider === void 0 ? void 0 : provider.label, "payment"), fee && (_jsx(_Fragment, { children: feeStr }))] }));
};
export const PaymentOptionProviderAlternates = ({ provider, fees, useDeposit }) => {
    const { t } = useI18N();
    const theme = useTheme();
    let feeStr = '', fee = fees[provider === null || provider === void 0 ? void 0 : provider.key];
    if (useDeposit && (fee === null || fee === void 0 ? void 0 : fee.deposit) && (fee === null || fee === void 0 ? void 0 : fee.deposit) > 0) {
        feeStr = ` (+${moneyFormat(fee.deposit / 100)} )`;
    }
    else if ((fee === null || fee === void 0 ? void 0 : fee.full) && (fee === null || fee === void 0 ? void 0 : fee.full) > 0) {
        feeStr = ` (+${moneyFormat(fee.full / 100)} )`;
    }
    return (_jsxs(_Fragment, { children: [t(provider === null || provider === void 0 ? void 0 : provider.label, "payment"), fee && (_jsx(_Fragment, { children: feeStr }))] }));
};
